import React, { useState } from 'react';
import { Button, Table } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RegionActions, { RegionsSelectors } from '@redux/RegionsRedux';
import { TableHeader, TableFooter } from '@components/table';
import { filterItems, sorter, paginateItems } from '@utils/filters';
import history from '@utils/history';

import './RegionsTable.less';

function Regions(props) {
  const {
    regions,
    loading,
    listOfStates,
    listOfCities,
    listOfOfficeNames,
    reloadData
  } = props;

  const dataColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) => sorter(a.name, b.name)
    },
    {
      title: 'Office',
      dataIndex: 'officeName',
      sorter: (a, b) => sorter(a.officeName, b.officeName)
    },
    {
      title: 'State',
      dataIndex: 'state',
      sorter: (a, b) => sorter(a.state, b.state)
    },
    {
      title: 'City',
      dataIndex: 'city',
      sorter: (a, b) => sorter(a.city, b.city)
    },
    {
      title: 'Number of Properties',
      dataIndex: 'propertiesCount',
      sorter: (a, b) => sorter(a.propertiesCount, b.propertiesCount)
    },
    {
      title: 'Number of Housekeepers',
      dataIndex: 'housekeepersCount',
      sorter: (a, b) => sorter(a.housekeepersCount, b.housekeepersCount)
    },
    {
      title: '',
      key: 'action',
      width: 100,
      render: (value, row) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              history.push(`/regions/${row.regionID}`);
            }}
          >
            Details
          </Button>
        );
      }
    }
  ];

  const [filters, updateFilters] = useState({
    state: [],
    city: [],
    officeName: []
  });
  const [noOfItemsToDisplay, changeNoOfItemsToDisplay] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const clearFilters = () => {
    updateFilters({
      state: [],
      city: [],
      officeName: []
    });
  };
  const handleFiltersUpdate = (filterType, val) => {
    handlePageChange(1);
    updateFilters({
      ...filters,
      [filterType]: [...val]
    });
  };

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
  };
  const handleChangeNoOfItemsToDisplay = items => {
    changeNoOfItemsToDisplay(items);
    handlePageChange(1);
  };

  const header = {
    filters: [
      {
        key: 'officeName',
        type: 'select',
        label: 'Office',
        data: listOfOfficeNames,
        values: filters.officeName
      },
      {
        key: 'state',
        type: 'select',
        label: 'State',
        data: listOfStates,
        values: filters.state
      },
      {
        key: 'city',
        type: 'select',
        label: 'City',
        data: listOfCities,
        values: filters.city
      }
    ],
    updateFilter: handleFiltersUpdate,
    reloadData: reloadData,
    clearFilters: clearFilters
  };

  const filteredItems = filterItems(regions, filters);
  const paginatedItems = paginateItems(
    filteredItems,
    currentPage,
    noOfItemsToDisplay
  );
  return (
    <div className="table-view">
      <Table
        columns={dataColumns}
        dataSource={paginatedItems}
        bordered
        pagination={false}
        loading={loading}
        rowKey="regionID"
        title={() => <TableHeader {...header} />}
        footer={() => (
          <TableFooter
            changeNoOfItemsToDisplay={handleChangeNoOfItemsToDisplay}
            noOfItemsToDisplay={noOfItemsToDisplay}
            currentItemsDisplayed={filteredItems.length}
            totalItems={regions.length}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            count={filteredItems.length}
          />
        )}
      />
    </div>
  );
}
Regions.propTypes = {
  regions: PropTypes.array,
  reloadData: PropTypes.func,
  loading: PropTypes.bool,
  listOfOfficeNames: PropTypes.array,
  listOfStates: PropTypes.array,
  listOfCities: PropTypes.array
};

const mapStateToProps = state => ({
  regions: RegionsSelectors.selectRegionsList(state),
  loading: RegionsSelectors.selectLoading(state),
  listOfOfficeNames: RegionsSelectors.selectList(state).officeName,
  listOfStates: RegionsSelectors.selectList(state).state,
  listOfCities: RegionsSelectors.selectList(state).city
});
const mapDispatchToProps = dispatch => ({
  reloadData: () => dispatch(RegionActions.fetchRegions())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Regions);
